import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Row,
  Typography,
  message,
  notification,
} from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { translation } from "../../i18n/translationConstant";
import { AddIdentifier } from "../../Models/Request/Identifier/AddIdentifier";
import { GetIdentifierResponse } from "../../Models/Response/Identifier/Identifier";
import {
  addIdentifier,
  addIdentifierVerification,
  getIdentifiers,
} from "../../Services/IdentifierService/Identifier";
import { IdentifierCategory } from "../../Utils/Constants/identifierType";
import "./index.css";
import UserIdentification from "./UserIdentification";
import { EntityIdentifier } from "../../Models/Request/Identifier/EntityIdentifier";

interface IIdentifiersProps {
  onRadioSelect: (e: any) => void;
  onSelectIdentifier: (identifier: AddIdentifier[]) => void;
  modalVisibility: boolean;
  onCloseModal: () => void;
  onOpenModal: () => void;
  fipEntityIdentifiers: EntityIdentifier[];
  onIdentifierChange: () => void;
}

const Identifiers: React.FC<IIdentifiersProps> = (
  {
    onRadioSelect,
    onSelectIdentifier,
    modalVisibility,
    onCloseModal,
    onOpenModal,
    fipEntityIdentifiers,
    onIdentifierChange,
  },
  props
) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [identifiers, setIndentifiers] = useState<AddIdentifier[]>([]);

  const [isAddIdentifierVerification, setVerification] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [selectedIdentifier, setSelectedIdentifier] = useState<AddIdentifier[]>([]);
  const [selectedOpt, setSelectedOpt] = useState<{
    [key: string]: string | null;
  }>({});
  const [addedIdentifiers, setAddedIdentifiers] = useState<AddIdentifier[]>([]);

  const { Text } = Typography;

  useEffect(() => {
    // getIdentifiers()
    //   .then((res) => res.data)
    //   .then((res) => {
    //     // setIndentifiers(res);
    //     const getFilteredIdentifers = getFinalIdentifiersMatchList(
    //       res,
    //       fipEntityIdentifiers
    //     );

    //     // TODO: Loop here
    //     selectFirstIdentifiers(getFilteredIdentifers);

    //     setIndentifiers(getFilteredIdentifers);

    //     // onRadioSelect([res[0]]); // Adds the identifier
    //     // setSelectedIdentifier([res[0]]); // Selects identifiers checkbox
    //   });
    getIdentifiersFiltered()
  }, [onRadioSelect]);

  const getIdentifiersFiltered = () => getIdentifiers()
  .then((res) => res.data)
  .then((res) => {
    // setIndentifiers(res);
    const getFilteredIdentifers = getFinalIdentifiersMatchList(
      res,
      fipEntityIdentifiers
    );

    // TODO: Loop here
    selectFirstIdentifiers(getFilteredIdentifers);
    setIndentifiers(getFilteredIdentifers);

    // onRadioSelect([res[0]]); // Adds the identifier
    // setSelectedIdentifier([res[0]]); // Selects identifiers checkbox
  });

  const reloadIdentifiers = () => getIdentifiers()
  .then((res) => res.data)
  .then((res) => {
    // setIndentifiers(res);
    const getFilteredIdentifers = getFinalIdentifiersMatchList(
      res,
      fipEntityIdentifiers
    );
    setIndentifiers(getFilteredIdentifers);
  });

  const onCancel = () => {
    setVerification(false);
    setOTPUniqueId("");
    form.resetFields();
    onCloseModal();
  };

  function getFinalIdentifiersMatchList(
    allIdentifiers: AddIdentifier[],
    fipEntityIdentifiers: EntityIdentifier[]
  ) {

     // Get locally added identifiers
    allIdentifiers = [...allIdentifiers, ...addedIdentifiers];

    //add redirected identifier if available
    allIdentifiers = [...allIdentifiers, ...getRedirectedlIdentifiers()];

    // Remove elements from allIdentifiers that do not exist in fipEntityIdentifier
    allIdentifiers = allIdentifiers.filter((identifier) =>
      fipEntityIdentifiers.some(
        (fipIdentifier) =>
          fipIdentifier.category?.toUpperCase() ===
            identifier.categoryType?.toUpperCase() &&
          fipIdentifier.type?.toUpperCase() === identifier.type?.toUpperCase()
      )
    );

    // Add identifier types from fipEntityIdentifier that are not present in allIdentifiers
    fipEntityIdentifiers.forEach((fipIdentifier) => {
      if (
        !allIdentifiers.some(
          (identifier) =>
            fipIdentifier.category?.toUpperCase() ===
              identifier.categoryType?.toUpperCase() &&
            fipIdentifier.type?.toUpperCase() === identifier.type?.toUpperCase()
        )
      ) {
        allIdentifiers.push({
          categoryType: fipIdentifier.category?.toUpperCase(),
          type: fipIdentifier.type?.toUpperCase(),
          value: "",
        });
      }
    });

    return allIdentifiers;
    // setIndentifiers(allIdentifiers);
  }

  const getRedirectedlIdentifiers = (): AddIdentifier[] => {
    try {
      const storedIdentifiers = localStorage.getItem("additionalIdentifier");

      if (!storedIdentifiers) {
        return [];
      }

      const parsedIdentifiers = JSON.parse(storedIdentifiers);

      if (!Array.isArray(parsedIdentifiers)) {
        console.error("additionalIdentifier must contain an array");
        return [];
      }

      return parsedIdentifiers;
    } catch (error) {
      console.error("Invalid additionalIdentifier in localStorage:", error);

      // Remove corrupted data so the same error does not occur on every render.
      localStorage.removeItem("additionalIdentifier");
      return [];
    }
  };

  function selectFirstIdentifiers(filteredIdentifiers: AddIdentifier[]) {
    const encounteredTypes: AddIdentifier[] = [];

    filteredIdentifiers.forEach((identifier) => {
      if (
        !encounteredTypes.find(
          (eIdentifier) => identifier.type == eIdentifier.type
        )
      ) {
        encounteredTypes.push(identifier);
      }
    });

    setSelectedIdentifier(encounteredTypes);
    onRadioSelect(encounteredTypes);

    const allHaveValues = filteredIdentifiers.every(
      (id) => id.value != null && id.value.trim() !== ""
    );

    if (allHaveValues) {
      console.log("Directly triggering discovery:");
      onSelectIdentifier(encounteredTypes);
    }else {
      const missingIdentifiers = filteredIdentifiers
        .filter(
          (id) => !id.value || id.value.trim() === ""
        )
        .map((id) => id.type)
        .filter((type, index, self) => self.indexOf(type) === index);

      notification.info({
        message: "Incomplete Identifiers",
        description: `Please add the following identifiers: ${missingIdentifiers.join(
          ", "
        )}`,
      });
    }

  }

  // const onIdentifierEntered = (iNumber: AddIdentifier) => {
  //   addIdentifier(iNumber)
  //     .then((res) => res.data)
  //     .then((res) => {
  //       if (iNumber.categoryType === IdentifierCategory.STRONG) {
  //         setVerification(true);
  //         setOTPUniqueId(res.mobile.otpUniqueID);
  //       } else {
  //         // getIdentifiers()
  //         //   .then((res) => res.data)
  //         //   .then((res) => setIndentifiers(res));
  //         getIdentifiersFiltered()
  //         setVisibility(false);
  //         onCloseModal();
  //         setVerification(false);
  //         form.resetFields();
  //       }
  //     });
  // };

  const onIdentifierEntered = (iNumber: AddIdentifier) => {
    if (iNumber.type === "MOBILE") {
      addIdentifier(iNumber)
        .then((res) => res.data)
        .then((res) => {
          setVerification(true);
          setOTPUniqueId(res.mobile.otpUniqueID);
        });
    } else {

      setAddedIdentifiers((prev) => {
        const existingIndex = prev.findIndex(
          (item) =>
            item.type?.toUpperCase() === iNumber.type?.toUpperCase() &&
            item.categoryType?.toUpperCase() === iNumber.categoryType?.toUpperCase()
        );

        if (existingIndex !== -1) {
          return prev.map((item, index) =>
            index === existingIndex ? iNumber : item
          );
        }

        return [...prev, iNumber];
      });

      setIndentifiers((prev) => {
        const existingIndex = prev.findIndex(
          (item) =>
            item.type?.toUpperCase() === iNumber.type?.toUpperCase() &&
            item.categoryType?.toUpperCase() === iNumber.categoryType?.toUpperCase()
        );

        if (existingIndex !== -1) {
          return prev.map((item, index) =>
            index === existingIndex ? iNumber : item
          );
        }

        return [...prev, iNumber];
      });

      onCloseModal();
      setVerification(false);
      form.resetFields();
    }
  };

  const onOTPSubmit = (otp: string, identifier: any) => {
    addIdentifierVerification({
      code: otp,
      otpUniqueID,
      identifierValue: identifier.value,
      categoryType: identifier.categoryType,
      type: identifier.type,
    }).then(() => {
      // getIdentifiers()
      //   .then((res) => res.data)
      //   .then((res) => setIndentifiers(res));
      // getIdentifiersFiltered()
      reloadIdentifiers();
      onCloseModal();
      setVerification(false);
      form.resetFields();
    });
  };

  const identifierSelectionChange = (e: CheckboxValueType[]) => {
    const localIdentifier = identifiers.filter(
      (i: any) => e.indexOf(i.value + i.type) !== -1
    );

    const localIdentifier1 = identifiers.filter(
      (i: any) => console.log(e.indexOf(i.value + i.type))
    );


    const localIdentifier2 = identifiers.filter(
      (i: any) => e.indexOf(i.value + i.type)
    );
    console.log("localIdentifier--->", localIdentifier);
    console.log("localIdentifier1--->", localIdentifier1);

    onRadioSelect(localIdentifier);
    setSelectedIdentifier(localIdentifier);
  };

  const handleChackbox = (
  isChecked: boolean,
  selectedItem: AddIdentifier,
  category: any,
  type: any,
  value: any
) => {
  console.log("Selected Value :", selectedItem);

  setSelectedOpt((prev: any) => {
    const categoryOptions = { ...(prev[category] || {}) };

    if (isChecked) {
      categoryOptions[type] = value;
    } else {
      delete categoryOptions[type];
    }

    return {
      ...prev,
      [category]: categoryOptions,
    };
  });

  // reset the discover accounts
  onIdentifierChange();
};

  const callOnRadioSelect = (updateflag : boolean) => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    const checkedItems :AddIdentifier[] = Array.from(checkboxes).map(checkbox => {
      // console.log("Count :",checkbox);
      const type = checkbox.getAttribute('name') || '';
      const value = checkbox.getAttribute('value') || '';
      const categoryType = checkbox.getAttribute('id') || '';
      return {type,value,categoryType};
    });

    
    if(updateflag){
      onRadioSelect(checkedItems);
    }
    // Your logic here...
    return ""; // JSX element returned by the function
  };

  // const isChacked = (category: any, type: any, value: any, index: number) => {
  //   if (selectedOpt[category] === undefined && index == 0) {
  //     setSelectedOpt((prev: any) => {
  //       return { ...prev, [category]: { ...prev[category], [type]: value } };
  //     });
  //   }

  //   return selectedOpt[category] !== undefined &&
  //     selectedOpt[category]?.[type] === value
  //     ? true
  //     : false;
  // };

  const isChacked = (category: any, type: any, value: any, index: number) => {
    if (selectedOpt[category] === undefined && index === 0) {
      return true;
    }

    return selectedOpt[category] !== undefined &&
      selectedOpt[category]?.[type] === value
      ? true
      : false;
  };

  const validateSelectedIdentifiers = () => {    

    if (selectedIdentifier.length !== 0) {

      const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
      const checkedItems :AddIdentifier[] = Array.from(checkboxes).map(checkbox => {
        // console.log("Count :",checkbox);
        const type = checkbox.getAttribute('name') || '';
        const value = checkbox.getAttribute('value') || '';
        const categoryType = checkbox.getAttribute('id') || '';
        return {type,value,categoryType};
      });
  
      onRadioSelect(checkedItems);


      const validIdentifiers: AddIdentifier[] = [];
      let matchingEntityIdentifier: AddIdentifier | undefined;

      // fipEntityIdentifiers.forEach((fipIdentifiers) => {
      //   matchingEntityIdentifier = selectedIdentifier.find((identifier) => {
      //     if (
      //       fipIdentifiers.category.toUpperCase() ==
      //         identifier.categoryType.toUpperCase() &&
      //       fipIdentifiers.type.toUpperCase() == identifier.type.toUpperCase()
      //     ) {
      //       validIdentifiers.push(identifier);
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   });

      //   if (!matchingEntityIdentifier) {
      //     notification.error({
      //       message: `Identifier Type: ${fipIdentifiers.type} not selected.`,
      //     });
      //   }
      // });

      // if (matchingEntityIdentifier) {
      //   onSelectIdentifier(checkedItems); // Call the function when valid identifiers are selected
      // }

      const strongIdentifiers = fipEntityIdentifiers.filter(
        (identifier) =>
          identifier.category?.toUpperCase() === IdentifierCategory.STRONG
      );

      const weakIdentifiers = fipEntityIdentifiers.filter(
        (identifier) =>
          identifier.category?.toUpperCase() !== IdentifierCategory.STRONG
      );

      const selectedStrongIdentifiers = checkedItems.filter(
        (identifier) =>
          identifier.categoryType?.toUpperCase() === IdentifierCategory.STRONG
      );

      const selectedWeakIdentifiers = checkedItems.filter(
        (identifier) =>
          identifier.categoryType?.toUpperCase() !== IdentifierCategory.STRONG
      );

      // Strong identifier is required
      if (strongIdentifiers.length > 0 && selectedStrongIdentifiers.length === 0) {
        notification.error({
          message: "Please select a strong identifier.",
        });
        return;
      }

      // At least ONE weak identifier is required
      if (weakIdentifiers.length > 0 && selectedWeakIdentifiers.length === 0) {
        notification.error({
          message: "Please select at least one weak identifier.",
        });
        return;
      }

      // Continue with selected identifiers
      onSelectIdentifier(checkedItems);
    } else {
      return notification.error({
        message: "Please select a valid identifier.",
      });
    }
  };

  const strongIdentifiers = identifiers.filter(
    (identifier) =>
      identifier.categoryType?.toUpperCase() ===
      IdentifierCategory.STRONG
  );

  const weakIdentifiers = identifiers.filter(
    (identifier) =>
      identifier.categoryType?.toUpperCase() !==
        IdentifierCategory.STRONG
  );

  const deleteLocalIdentifier = (identifier: AddIdentifier) => {
    const sameTypeIdentifiers = identifiers.filter(
      (item) =>
        item.type?.toUpperCase() === identifier.type?.toUpperCase() &&
        item.categoryType?.toUpperCase() === identifier.categoryType?.toUpperCase() &&
        item.value?.trim() !== ""
    );

    const hasMultipleSameType = sameTypeIdentifiers.length > 1;

    setAddedIdentifiers((prev) =>
      prev.filter(
        (item) =>
          !(
            item.type?.toUpperCase() === identifier.type?.toUpperCase() &&
            item.categoryType?.toUpperCase() === identifier.categoryType?.toUpperCase() &&
            item.value?.trim().toUpperCase() === identifier.value?.trim().toUpperCase()
          )
      )
    );

    setIndentifiers((prev) => {
      if (hasMultipleSameType) {
        return prev.filter(
          (item) =>
            !(
              item.type?.toUpperCase() === identifier.type?.toUpperCase() &&
              item.categoryType?.toUpperCase() === identifier.categoryType?.toUpperCase() &&
              item.value?.trim().toUpperCase() === identifier.value?.trim().toUpperCase()
            )
        );
      }

      return prev.map((item) =>
        item.type?.toUpperCase() === identifier.type?.toUpperCase() &&
        item.categoryType?.toUpperCase() === identifier.categoryType?.toUpperCase() &&
        item.value?.trim().toUpperCase() === identifier.value?.trim().toUpperCase()
          ? { ...item, value: "" }
          : item
      );
    });

    notification.success({
      message: `${identifier.type} deleted successfully.`,
    });
  };
  

  return (
    <div className="identifierRoot">
      <div className="radioSection">

        {/* =====================================================
            STRONG IDENTIFIERS
            ===================================================== */}

        <div className="identifierGroup">

          <div className="identifierGroupHeader">

            <div className="identifierHeaderContent">

              <Typography.Text className="identifierGroupTitle">
                {t(translation.lblStrongIdentifiers)}
              </Typography.Text>

              <Typography.Text className="identifierGroupDescription">
                {t(translation.lblStrongIdentifiersDesc)}
              </Typography.Text>

            </div>

            <span className="identifierBadge">
              required · pick 1
            </span>

          </div>


          <div className="identifierOptions">

            {strongIdentifiers.map(
              (
                singleIdentifier: GetIdentifierResponse,
                index
              ) => {
                const isMobile =
                  singleIdentifier.type?.toUpperCase() === "MOBILE";

                return (
                  <div
                    key={`${singleIdentifier.type}-${singleIdentifier.value}-${index}`}
                    className={`identifierOption strongIdentifierOption ${
                      isMobile ? "mobileIdentifierOption" : ""
                    }`}
                    onClick={() =>
                      handleChackbox(
                        !isChacked(
                          "STRONG",
                          singleIdentifier.type,
                          singleIdentifier.value,
                          index
                        ),
                        singleIdentifier,
                        "STRONG",
                        singleIdentifier.type,
                        singleIdentifier.value
                      )
                    }
                  >

                    <Checkbox
                      value={singleIdentifier.value}
                      name={singleIdentifier.type}
                      id={singleIdentifier.categoryType}
                      checked={isChacked(
                        "STRONG",
                        singleIdentifier.type,
                        singleIdentifier.value,
                        index
                      )}
                    />

                    <span className="identifierType">
                      {singleIdentifier.type}
                    </span>

                    <span className="identifierValue">
                      {singleIdentifier.value || "Not added"}
                    </span>

                    {isMobile &&
                      singleIdentifier.value &&
                      singleIdentifier.value.trim() !== "" && (
                        <span className="mobileVerifiedBadge">
                          Verified
                        </span>
                      )}

                  </div>
                );
              }
            )}

            {/* {strongIdentifiers.filter(
              (identifier) =>
                identifier.type?.toUpperCase() === "MOBILE"
            ).length < 2 && (
              <Button
                type="dashed"
                className="addMobileIdentifierButton"
                onClick={(event) => {
                  event.stopPropagation();
                  setModalVisibility();
                }}
              >
                <span className="addMobilePlus">+</span>
                Add another mobile number
              </Button>
            )} */}

          </div>

        </div>

        {/* =====================================================
            WEAK IDENTIFIERS
            ===================================================== */}

        {weakIdentifiers.length > 0 && (
        <div className="identifierGroup otherIdentifierGroup">

          <div className="identifierGroupHeader">

            <div className="identifierHeaderContent">

              <Typography.Text className="identifierGroupTitle">
                {t(translation.lblOtherIdentifiers)}
              </Typography.Text>

              <Typography.Text className="identifierGroupDescription">
                {t(translation.lblOtherIdentifiersDesc)}
              </Typography.Text>

            </div>

            <span className="identifierBadge">
              Select least 1
            </span>

          </div>


          <div className="identifierOptions">

            {weakIdentifiers.map(
              (
                singleIdentifier: GetIdentifierResponse,
                index
              ) => (

                <div
                  key={`${singleIdentifier.type}-${singleIdentifier.value}-${index}`}
                  className="identifierOption otherIdentifierOption"
                  onClick={() =>
                  handleChackbox(
                    !isChacked(
                      "WEAK",
                      singleIdentifier.type,  
                      singleIdentifier.value,
                      index
                    ),
                    singleIdentifier,
                    "WEAK",
                    singleIdentifier.type,
                    singleIdentifier.value
                  )
                }
                >

                  <Checkbox
                    value={singleIdentifier.value}
                    name={singleIdentifier.type}
                    id={singleIdentifier.categoryType}

                    checked={isChacked(
                      "WEAK",
                      singleIdentifier.type,
                      singleIdentifier.value,
                      index
                    )}

                    // onChange={(e) =>
                    //   handleChackbox(
                    //     e.target.checked,
                    //     singleIdentifier,
                    //     "WEAK",
                    //     singleIdentifier.type,
                    //     e.target.value
                    //   )
                    // }
                  />

                  <span className="identifierType">
                    {singleIdentifier.type}
                  </span>

                  <span className="identifierValue">
                    {singleIdentifier.value}
                  </span>


                  {singleIdentifier.type?.toUpperCase() !== "MOBILE" &&
                    singleIdentifier.value &&
                    singleIdentifier.value.trim() !== "" && (
                      <Button
                        type="link"
                        danger
                        className="deleteIdentifierButton"
                        onClick={(event) => {
                          event.stopPropagation();
                          deleteLocalIdentifier(singleIdentifier);
                        }}
                      >
                        Delete
                      </Button>
                    )}

                </div>

              )
            )}

          </div>

        </div>
        )}
      </div>
      <div className="actionButtonGroup">

        {/* =====================================================
            ADD IDENTIFIER
            ===================================================== */}
        <Button
          type="text"
          className="commonButtonBackground secondaryButton addIdentifier secondaryCustom"
          onClick={onOpenModal}
        >
          <span className="addIdentifierPlus">+</span>
          {t(translation.lblAddIdentifier)}
        </Button>

        {/* =====================================================
            DISCOVER ACCOUNTS
            ===================================================== */}
        <Button
          className="commonButtonBackground primaryButton linkAccountNoAccounts primaryCustom secondaryButtonWidth"
          onClick={validateSelectedIdentifiers}
        >
          {t(translation.lblDiscoverAccounts)}
        </Button>

      </div>
      {callOnRadioSelect(false)}
      <UserIdentification
        form={form}
        visible={modalVisibility}
        handleCancel={onCancel}
        identifierEntered={onIdentifierEntered}
        onOTPSubmit={onOTPSubmit}
        isAddIdentifierVerification={isAddIdentifierVerification}
        label={t(translation.lblAddIdentifier)}
        multipleIdentifiers={true}
        isForgotPassword={false}
        entityIdentifiers={fipEntityIdentifiers}
      />

    </div>
  );
};
export default Identifiers;
